import React, { useState, useEffect, forwardRef } from 'react';
import { Pagination, Row, Col, Input, Space, Tooltip, Typography } from 'antd';
import useSkipFirstEffect from '../../utils/hook/useSkipFirstEffect';
import axiosInstance from '../../utils/axiosInstance';
import fetchWithAuth from '../../utils/customFetch';

const { Text } = Typography;

const Ption = forwardRef(
  ({ isCustomFetch, onCngPage, onPeding, url, plod, isNotShow = false, itmeName = 'items' }, ref) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [pageInput, setPageInput] = useState(currentPage);
    const maxPage = Math.ceil(total / pageSize);
    const minPage = 1;

    const getPayload = () => ({
      page_size: pageSize,
      page_number: currentPage,
    });

    const handlePageChange = (page, size) => {
      setCurrentPage(page);
      setPageSize(size);
      setPageInput(page);
    };

    const getData = async () => {
      onPeding(true);
      const payload = { ...plod, ...getPayload() };
      try {
        const response = isCustomFetch
          ? await fetchWithAuth({ method: 'POST', endpoint: url, data: payload })
          : await axiosInstance.post(url, payload);

        setTotal(isCustomFetch ? response.count : response.data.count);
        onCngPage(isCustomFetch ? response.results : response.data.results);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        onPeding(false);
      }
    };

    useEffect(() => {
      getData();
    }, [currentPage, pageSize, url]);

    useSkipFirstEffect(() => {
      if (currentPage === 1) {
        getData();
      } else {
        setCurrentPage(1);
      }
    }, [plod]);

    React.useImperativeHandle(ref, () => ({
      getPayload,
    }));

    const handlePageInputChange = (e) => {
      const value = e.target.value;
      if (/^\d*$/.test(value)) {
        setPageInput(value);
      }
    };

    const handleEnterPress = () => {
      const pageNumber = Number(pageInput);
      if (pageNumber >= minPage && pageNumber <= maxPage) {
        handlePageChange(pageNumber, pageSize);
      } else {
        setPageInput(currentPage);
      }
    };

    if (isNotShow) return null;

    return (
      <div className="mt-4 mb-2 px-5">
        <Row justify="space-between" align="middle" gutter={[16, 16]}>
          <Col>
            <Text strong>Total {total} {itmeName}</Text>
          </Col>
          <Col>
            <Space>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={total}
                onChange={handlePageChange}
                showSizeChanger
                showQuickJumper={false}
                pageSizeOptions={['5', '10', '20', '50']}
                showLessItems
              />
              <span className='dark:text-white'>Go to</span>
              <Tooltip title="Enter page number and press Enter">
                <Input
                  value={pageInput}
                  onChange={handlePageInputChange}
                  onPressEnter={handleEnterPress}
                  placeholder="Page"
                  style={{ width: 35 }}
                />
                <span className='dark:text-white pl-2'>page</span>
              </Tooltip>
            </Space>
          </Col>
        </Row>
      </div>
    );
  }
);

export default React.memo(Ption);
